<template>
  <v-container>
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        md="6"
        lg="5"
      >
        <v-card class="pa-4">
          <v-card-title class="primary--text text--lighten-2 pb-0">
            {{ $t('Forgot Password') }}
          </v-card-title>
          <v-card-title class="primary--text pt-0">
            {{ $t('IQLS Laboratory Companion') }}
          </v-card-title>

          <v-card-subtitle class="mt-5">
            Enter your email address and we'll send you a link to reset your password
          </v-card-subtitle>
          <v-card-text class="mt-6">
            <ValidationObserver
              ref="resetPasswordObserver"
              v-slot="{ validate, reset }"
            >
              <form @submit.prevent="submit">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    :label="$t('E-mail')"
                    type="email"
                    autocomplate="username"
                    prepend-inner-icon="mdi-email"
                    required
                  />
                </ValidationProvider>

                <v-btn
                  block
                  color="primary"
                  type="submit"
                  class="mr-4"
                >
                  {{ $t('Request password reset') }}
                </v-btn>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import FormValidation from "../mixins/FormValidation";
    // import {mapActions} from 'vuex'

    export default {
        name: "Login",
        mixins: [FormValidation],
        data() {
            return {
                email: '',
            }
        },

        methods: {
            // ...mapActions([
            //     'login'
            // ]),

            async submit() {
                let valid = await this.$refs.resetPasswordObserver.validate();
                if (!valid) return;

                let resetPasswordData = {
                    email: this.email,
                };

                console.log("resetPasswordData: ", resetPasswordData);

                // this.login({loginData})
                //     .then(() => {
                //         let redirectUrl = this.$route?.query?.redirect;
                //         if (redirectUrl) {
                //             this.$router.push(redirectUrl)
                //         } else {
                //             this.$router.push({name: "Home"})
                //         }
                //     })
                //     .catch(() => {
                //         this.loginError = true
                //     })

            },
        }
    }
</script>

<style scoped>

</style>
